"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.money_PricingModelSerialization = void 0;
class money_PricingModelSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        return copy;
    }
}
exports.money_PricingModelSerialization = money_PricingModelSerialization;
